export const filterData = data => {
  const newData = [];
  if (data.length > 0) {
    data.map(d =>
      newData.push({
        publisherType: d.publisher_type?.name,
        name: d.name,
        logo: d.url_logo,
        address: d.address,
        phone: d.mainPhone,
        coverPictureUrl: d.cover_picture_url,
        aboutUs: d.about_us,
        videoUrl: d.video_url,
        publisherId: d.publisher_id
      })
    );
  }
  return newData;
};
